import {
  FaFacebookF as FacebookIcon,
  FaInstagram as InstagramIcon,
  FaTelegramPlane as TelegramIcon,
  FaTelegram as TelegramChannelIcon,
  FaDiscord as DiscordIcon,
  FaTwitter as TwitterIcon,
} from "react-icons/fa";

export const socialMediaIcons = [
  {
    id: "1",
    icon: <FacebookIcon />,
    href: "https://www.facebook.com/zixxarofficial",
    last: false,
  },
  {
    id: "2",
    icon: <InstagramIcon />,
    href: "https://www.instagram.com/zixxarofficial/",
    last: false,
  },
  {
    id: "4",
    icon: <TelegramChannelIcon />,
    href: "https://t.me/+nIuPtB2JFglkZTEx",
    last: false,
  },
  {
    id: "5",
    icon: <TelegramIcon />,
    href: "https://t.me/zixxarcommunity",
    last: false,
  },
  {
    id: "6",
    icon: <TwitterIcon />,
    href: "https://twitter.com/Zixxar_tech",
    last: false,
  },
  {
    id: "7",
    icon: <DiscordIcon />,
    href: "https://discord.com/invite/DTNcneBGF4",
    last: true,
  },
];
